import sparePartsApi, { ApiResponse } from "../../../api/spareParts.api";

import { SparePartsNotification } from "./types";

const BASE_URL = "/notifications";

export const notificationsService = {
  async getNotifications(params?: {
    page?: number;
    limit?: number;
    unreadOnly?: boolean;
  }) {
    const response = await sparePartsApi.get<ApiResponse<SparePartsNotification[]>>(
      BASE_URL,
      { params }
    );

    return {
      data: response.data.data,
      meta: response.data.meta,
    };
  },

  async getUnreadCount() {
    const response = await sparePartsApi.get<ApiResponse<{ count: number }>>(
      `${BASE_URL}/unread-count`
    );

    return response.data.data.count;
  },

  async markRead(id: string) {
    await sparePartsApi.patch(`${BASE_URL}/${id}/read`);
  },

  async markAllRead() {
    await sparePartsApi.patch(`${BASE_URL}/mark-all-read`);
  },
};
